import React from 'react';


export default function ViewContentButton({showContentModal, metricFilterOverrides}) {

    function onClick() {
        showContentModal(metricFilterOverrides, null);
    }

    return (
        <>
            <div className='tlw-flex tlw-items-center tlw-justify-start tlw-whitespace-nowrap'>
                <button
                    type='button'
                    onClick={onClick}
                    className='tlw-border-0 tlw-bg-transparent tlw-px-0 tlw-py-2 tlw-text-md tlw-font-medium tlw-leading-20 tlw-text-blue-400 tlw-outline-none'
                >
                    View Content
                </button>
            </div>
        </>
    );
}
